module.exports = __webpack_public_path__ + "img/tags-sharp-thin.7857c647.svg";